export default __webpack_public_path__ + "static/media/predios.66032abf.svg";